import classNames from 'classnames'
import React, { FC } from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { MarketSection } from '../MarketSection'
import { Paragraph } from '../Paragraph'

export interface FootnotesProps {
  footnotes: string[]
  id?: string
  title?: string
}

export const Footnotes: FC<FootnotesProps> = ({ footnotes, id, title }) => (
  <MarketSection id={id}>
    <div
      className={classNames(
        'col-span-full',
        'sm:mx-120',
        'md:mx-0',
        'lg:col-start-2 lg:col-span-6 lg:-mx-75',
        'xl:col-start-2 xl:col-span-8 xl:-mx-45',
        'xxl:col-start-4 xxl:col-span-8'
      )}
    >
      <div className="flex flex-col gap-15 p-30 border border-neutral-light rounded-15 tb:p-45 lg:px-120 lg:py-90">
        {!isNullOrWhiteSpace(title) && (
          <h2 className="font-h3 text-h3 text-secondary-darker">{title}</h2>
        )}

        {!!footnotes.length && (
          <div className="flex flex-col gap-20 font-t-light text-t-200 text-secondary-darker lg:text-t-300">
            {footnotes.map((footnote, i) => (
              <Paragraph key={i}>{footnote}</Paragraph>
            ))}
          </div>
        )}
      </div>
    </div>
  </MarketSection>
)
